/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getHospitalDropdown = (params) => makeApiCall(`/user/hospitals/list`, 'POST', params);
export const getHTARTargetUpdateList = (params) =>
  makeApiCall(`/hospitals/point-person/request/list`, 'GET', params);
export const getHTARTargetUpdate = (params) =>
  makeApiCall(`/hospitals/point-person/request/update`, 'POST', params);
